import {
  Text,
  Colors,
  Media,
  Spacing,
  StackChildren,
  Inset,
} from '@doordash/design-language'
import { CountryCode } from '@doordash/lib-i18n'
import styled from 'styled-components'
import {
  COLOR_PINK_BGC,
  LANDING as Style,
  LANDING_CONTENT,
  TABLET_WIDTH,
} from './constants'
import { COUNTRY_SHORTCODES } from '../../../constants'

export const FormContainer = styled.div`
  position: absolute;
  top: auto;
  height: ${Style.FORM_CONTAINER.HEIGHT};
  right: 50%;
  transform: translate(50%, -120%);
  z-index: 10;
  min-width: ${Style.FORM_CONTAINER.MIN_WIDTH};

  ${Media.Mobile`
    height: auto;
    margin: ${Spacing.Large}px auto 0;
    position: inherit;
    display: flex;
    justify-content: center;
    transform: translateY(-18%);
    min-width: ${Style.FORM_CONTAINER.MOBILE.MIN_WIDTH};
    margin: ${Spacing.Large}px;
    padding: 0;
  `}
`
export const SlideFormContainer = styled(Inset)`
  display: flex;
  align-items: center;
  ${Media.Tablet`
    padding: ${Inset.Sizes.Medium}px;
    width: 100%;
  `}
  ${Media.Mobile`
    padding: ${Inset.Sizes.Small}px;
    width: 100%;
  `}
`

export const LandingContent = styled.div`
  height: 100%;
  max-width: ${LANDING_CONTENT.MAX_WIDTH};
  margin: 0 auto;

  ${Media.Mobile`
    background-color: ${COLOR_PINK_BGC};
  `}
`

// tslint:disable:max-line-length
export const ValuePropsWrapper = styled.div`
  padding: 0 ${Spacing.Small}px ${Spacing.XxxLarge}px ${Spacing.Small}px;
  margin-top: ${(props: { experimentQ3: boolean }) =>
    props.experimentQ3 ? `${Spacing.XxLarge}px` : `${Spacing.XxLarge}px`}};

  ${Media.Mobile`
    background-color: ${Colors.SystemWhite};
    background-repeat: no-repeat;
    background-position: cover;
    background-size: contain;
    margin: 0;
    padding: ${(props: { experimentQ3: boolean }) =>
      props.experimentQ3
        ? `${Spacing.XxLarge}px 0 ${Spacing.Large}px 0`
        : `${Spacing.XxLarge}px ${Spacing.Small}px ${Spacing.XxxLarge}px ${Spacing.Small}px`}};
  `}
`

export const FaqContainer = styled.div.attrs({
  role: 'radiogroup',
})`
  max-width: 768px;
  margin: 0 auto;
  padding-bottom: ${Spacing.XLarge}px;

  ${Media.Mobile`
    margin: ${Spacing.Large}px;
  `}
`

export const FAQTitle = styled(Text)`
  /* important needed to override margin from h2 */
  margin-top: ${Spacing.XxLarge}px !important;
  text-align: center;
  font-size: 36px;
`

export const CellWrapper = styled.div`
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
`

export const RenderBefore = styled.div`
  &:after {
    content: '';

    position: absolute;
    left: 0;
    top: 0;

    width: 7px;
    height: 100%;
  }
`

export const WhatIsDoorDashWrapper = styled.div`
  align-content: center;
  display: flex;
  background-color: ${Colors.SystemGrey0};
  margin: 0 auto;
  padding: ${Spacing.XLarge}px 0 ${Spacing.XLarge}px 0;
`

export const SignUpDetailsSectionWrapper = styled.div`
  align-content: center;
  background-color: ${Colors.SystemGrey0};
  margin: 0 auto;
  padding: ${Spacing.XxLarge}px 0 0 0;
`

export const SignUpHeaderWrapper = styled.div`
  font-size: ${Spacing.XLarge}px;
  line-height: ${Spacing.Large}px;
  text-align: center;
`

export const DataWrapper = styled.div`
  border: ${Spacing.XxxxSmall}px solid ${Colors.SystemGrey5};
  padding: ${Spacing.Medium}px;
  border-radius: ${Spacing.XxxSmall}px;
  margin: ${Spacing.None}px ${Spacing.XLarge}px;
  letter-spacing: 0ch;
  line-height: ${Spacing.Large}px;
  max-height: fit-content;
  text-align: left;
  margin-bottom: ${Spacing.Medium}px;
  min-height: 240px;
  background: ${Colors.SystemWhite};
  ${Media.WideScreen`
  max-width: calc(100vw - ${Spacing.XxxLarge}px);
  ul {
    padding: 0 ${Spacing.Large}px;
    li {
      padding-left: ${Spacing.XxxSmall}px;
    }
  }
`}
`

export const SignUpDetailsWrapper = styled.div`
  align-content: center;
  display: flex;
  background-color: ${Colors.SystemRed5};
  margin: 0 auto;
  padding: ${Spacing.XxLarge}px 0 ${Spacing.XxLarge}px 0;
`

export const SignUpSubtitle = styled.div`
  display: flex;
  svg {
    margin: ${Spacing.XxxSmall}px;
    margin-right: ${Spacing.XxSmall}px;
  }
`

export const SignupCarouselWrapper = styled.div`
  margin-top: ${Spacing.Small}px;
  padding-top: ${Spacing.Small}px;
`

export const HowToDashTitle = styled(Text)`
  margin-top: ${Spacing.XxLarge}px !important;
  text-align: center;
  font-size: 36px;
`

export const HowToDashContainer = styled(StackChildren)`
  padding-top: ${Spacing.Small}px;
  background-color: ${Colors.SystemWhite};
`
export const HeroContainer = styled.div`
  height: 100vh;
  ${(props: SimpleWrapperProps) =>
    props.experimentQ3 &&
    `
      @media (max-width: ${TABLET_WIDTH}px) {
        max-height: 800px;
        padding: ${Spacing.XxxLarge}px ${Spacing.Medium}px;
      }
    `}
  ${Media.Tablet`
    padding-top: 60px;
    height: 100%
  `}
  ${Media.Mobile`
    margin-top: 60px;
    padding-top: 0px;
    height: 100%
  `}
  display: flex;
  flex-direction: row;
`

type HeroImageProps = {
  url: string
  isQ3CroGraduation?: boolean
  country?: CountryCode
}

export const HeroImageWithURL = styled.div`
  min-width: 40%;
  background: url(${(props: HeroImageProps) => props.url}) no-repeat;
  background-size: auto auto;
  background-position: center calc(50% + 60px);
  background-color: ${Colors.SystemRed0};

  ${Media.Tablet`
    display: none;
  `}
`

export const HeroImageWithURLV2 = styled.div`
  min-width: 40%;
  background-color: ${Colors.SystemRed0};
  ${(props: HeroImageProps) => {
    if (props.isQ3CroGraduation && props.country === COUNTRY_SHORTCODES.US) {
      return `
      background: url(${props.url}) center top / cover no-repeat rgb(255, 255, 255);
      background-size: cover;
      background-position: none;
      `
    }
    if (
      props.isQ3CroGraduation &&
      (props.country === COUNTRY_SHORTCODES.AU ||
        props.country === COUNTRY_SHORTCODES.NZ)
    ) {
      return `
      background: url(${props.url}) center top / cover no-repeat rgb(255, 255, 255);
      background-size: cover;
      background-position: 65% center;
      margin-top: ${Spacing.XxLarge}px;
      `
    }
    if (props.isQ3CroGraduation && props.country === COUNTRY_SHORTCODES.DE) {
      return `
      background: url(${props.url}) center top / cover no-repeat rgb(255, 255, 255);
      background-size: cover;
      margin-top: ${Spacing.XxLarge}px;
      `
    }
    return `
    background: url(${props.url}) no-repeat;
    background-size: auto auto;
    background-position: center calc(50% + 60px);
    background-color: ${Colors.SystemRed0};
      `
  }}

  @media (max-width: ${TABLET_WIDTH}px) {
    display: none;
  }
`

type SimpleWrapperProps = {
  experimentQ3?: boolean
}

export const SimpleWrapper = styled.div`
  overflow-anchor: ${(props: SimpleWrapperProps) =>
    props.experimentQ3 ? 'none' : 'initial'};
`
